import { useState, useEffect } from "react";
import {
  Button,
  Row,
  Col,
  Space,
  Table,
  Modal,
} from "antd";
import { EyeFilled,DownloadOutlined } from "@ant-design/icons";

import "../../styles/seims.css";

import api from "../../services/nysService";
import { Viewer, Worker } from "@react-pdf-viewer/core";

// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { recordError } from "../../utils/logService";
import { pdfjsVersion } from "@seims/shared";

const SupportingDocument = ({ data }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [toggleFiles, setToggleFiles] = useState(false);

  useEffect(() => {
    fileBuilder();
  }, [data]);

  const fileBuilder = () => {
    let fileData = [{}];

    fileData = data.map((item) => ({
      fileName: item.filename,
      size: item.fileSize,
      type: item.contentType,
      documentType: item.documentType.key,
      typeDescription: item.documentType.value,
      uploadDate: item.lastModified,
      file: item.file === undefined ? {} : item.file,
      id: item.id,
      userId: item.userId,
      hasFile: false,
    }));

    setUploadedFiles(fileData);
  };

  const title = "Supporting Documents";
  const subTitle = "View Documents";

  const PreviewDocument = async (record) => {
    try {
      const response = await api.getFile(record.id, record.userId);

      if (response) {
        const { data } = response;
        const new_blob = new Blob([data]);

        const url = URL.createObjectURL(new_blob);

        setPreviewImage(url || record.preview);
        setPreviewOpen(true);
        setPreviewTitle(record.fileName);
        setToggleFiles(record.type != "application/pdf");
        // URL.revokeObjectURL(url);
      }
      
    } catch (error) {
      recordError(error);
    }
  };

  const handleFileDownload = async (record) => {
    try {
      const response = await api.getFile(record.id, record.userId);

      if (response) {
        const { data } = response;
        const new_blob = new Blob([data]);

        const url = URL.createObjectURL(new_blob);
        const downloadLink = document.createElement("a");

        downloadLink.href = url;
        downloadLink.download = record.fileName;
        downloadLink.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const handleCancel = () => setPreviewOpen(false);

  const columns = [
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "1",
    },
    {
      title: "Document Description",
      dataIndex: "typeDescription",
      key: "2",
    },
    {
      title: "Upload Date",
      dataIndex: "uploadDate",
      key: "3",
    },
    {
      title: "Preview",
      dataIndex: "preview",
      key: "5",
      render: (_, record) => {
        if (record.id > 0) {
          return (
            <>
              <Space>
              <Button
                className="blue"
                type="primary"
                icon={<EyeFilled />}
                onClick={() => PreviewDocument(record)}
              />
              </Space>
            </>
          );
        }
      },
    },
    {
      title: "Download",
      dataIndex: "download",
      key: "6",
      render: (_, record) => {
        if (record.id > 0) {
          return (
            <>
              <Space>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => handleFileDownload(record)}
              />
              </Space>
            </>
          );
        }
      },
    }
  ];

  return (
    <>
      {/* <PageHeader
        title={title}
        subTitle={subTitle}
        className="ant-page-header-heading-sub-title"
      ></PageHeader>
      <Divider /> */}

      <h1 className="center-align">{title}</h1>
      <p className="sub-title center-align">{subTitle}</p>
      <br />

      {/* <Row>
        <Col span={24}>
          <Card key="1" title="Uploaded Documents"></Card>
        </Col>
      </Row> */}
      <Row>
        <Col span={24}>
          <h3>Uploaded Documents</h3>
        </Col>
      </Row> 
      <Row>
        <Col span={24}>
          <Table
            dataSource={uploadedFiles}
            columns={columns}
            bordered
            pagination={{ pageSize: 10 }}
            size="middle"
          />
        </Col>
      </Row>

      <Row>
        <Col span={20}></Col>
      </Row>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width="50%"
        key="modal"
        // bodyStyle={{ height: 700 }}
      >
        {toggleFiles ? (
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewImage}
          />
        ) : (
          <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion()}/build/pdf.worker.min.js`}
          >
            <Viewer
              fileUrl={previewImage}
              plugins={[defaultLayoutPluginInstance]}
              renderError={console.log}
            />
          </Worker>
        )}
      </Modal>
    </>
  );
};

export default SupportingDocument;
